import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/Evidenza/card.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import  "../../font/frunchy-sage.ttf"



function OrarioNatalizio () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <div className="sottotitolo-title-container row m-auto text-center">
                <h1 className="sottotitolo-title-natale">Festività natalizie</h1>
            </div>
            <figure className="text-center" style={{margin: "1em"}}>
                <blockquote className="blockquote">
                    <p style={{fontSize: "22px"}}>
                        Nel periodo natalizio, dal <strong>24 dicembre</strong> al <strong>6 gennaio</strong> (compresi),
                        <br/>
                        tutti i corsi di gruppo sono sospesi e
                        <br/>
                        il centro seguirà i seguenti orari:
                        <br/>
                        <br/>
                        <div className="tables-container m-auto" style={{maxWidth: "30em", display: "flex", justifyContent: "top"}}>
                            {/* Tabella Dicembre */}
                            <table className="table mx-auto" style={{ width: "10em" }}>
                                <thead>
                                <tr>
                                    <th colSpan={2} style={{ textAlign: "center", fontFamily: "Hammersmith One" }}>
                                        Dicembre
                                    </th>
                                </tr>
                                </thead>
                                <colgroup>
                                    <col style={{ minWidth: "10px" }} />
                                    <col style={{ minWidth: "10px" }} />
                                </colgroup>
                                <tbody>
                                <tr>
                                    <th className="data-cell">Martedì 24</th>
                                    <td className="data-cell">9-13</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Mercoledì 25</th>
                                    <td className="data-cell">Chiuso</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Giovedì 26</th>
                                    <td className="data-cell">Chiuso</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Venerdì 27</th>
                                    <td className="data-cell">9-22</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Sabato 28</th>
                                    <td className="data-cell">9-19</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Domenica 29</th>
                                    <td className="data-cell">9-13</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Lunedì 30</th>
                                    <td className="data-cell">9-22</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Martedì 31</th>
                                    <td className="data-cell">9-13</td>
                                </tr>
                                </tbody>
                            </table>

                            {/* Tabella Gennaio */}
                            <table className="table" style={{ width: "10em", margin: "0 auto auto 3em"}}>
                                <thead>
                                <tr>
                                    <th colSpan={2} style={{fontFamily: "Hammersmith One" }}>
                                        Gennaio
                                    </th>
                                </tr>
                                </thead>
                                <colgroup>
                                    <col style={{ minWidth: "10px" }} />
                                    <col style={{ minWidth: "10px" }} />
                                </colgroup>
                                <tbody>
                                <tr >
                                    <th className="data-cell">Mercoledì 1</th>
                                    <td className="data-cell">Chiuso</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Giovedì 2</th>
                                    <td className="data-cell">9-22</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Venerdì 3</th>
                                    <td className="data-cell">9-22</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Sabato 4</th>
                                    <td className="data-cell">9-19</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Domenica 5</th>
                                    <td className="data-cell">9-13</td>
                                </tr>
                                <tr>
                                    <th className="data-cell">Lunedì 6</th>
                                    <td className="data-cell">9-13</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </p>
                    Inoltre, per tutto il periodo:
                    <br/>
                    <strong>Sono sospese le limitazioni orarie </strong> per le tessere a orario ridotto
                    <br/>
                    Tutti gli utenti con <strong>multitessera</strong> hanno libero accesso a <strong>SPA</strong> e <strong> Nuoto Libero</strong>
                    <br/>
                    La multitessera <strong>WEEKEND</strong> è valida tutti i giorni
                    <br/>
                    <br/>
                    Le attività riprenderanno regolarmente a partire da <strong>martedì 7 gennaio</strong>
                    <br/>
                    <br/>

                    <strong style={{fontSize: "40px", color: "#aa0000"}}>Buone Feste!</strong>



                </blockquote>
            </figure>
            <Space />

        </div>
    )
}
export default OrarioNatalizio